import React from 'react';
import {
	Modal,
	Box,
	Typography,
	Button,
	IconButton,
	TextField,
} from '@mui/material';

interface ModalComponentProps {
	open: boolean;
	title: string;
	description: string | React.ReactNode;
	imageSrc?: string;
	buttonText?: string;
	onClose: () => void;
	onButtonClick?: () => void;
	disableBackdropClick?: boolean;
	showCloseButton?: boolean;
	secondaryButtonText?: string;
	onSecondaryClick?: () => void;
	showTextField?: boolean;
	textFieldLabel?: string;
	textFieldValue?: string;
	onTextFieldChange?: (value: string) => void;
}

const ModalComponent: React.FC<ModalComponentProps> = ({
	open,
	title,
	description,
	imageSrc,
	buttonText = 'Cerrar',
	onClose,
	onButtonClick,
	disableBackdropClick = true,
	showCloseButton = true,
	secondaryButtonText,
	onSecondaryClick,
	showTextField = false,
	textFieldLabel,
	textFieldValue,
	onTextFieldChange,
}) => {
	return (
		<Modal
			open={open}
			onClose={(event, reason) => {
				if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
					onClose?.();
				}
			}}
			aria-labelledby="modal-title"
			aria-describedby="modal-description"
		>
			<Box
				sx={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: { xs: '90%', sm: '80%', md: '600px' },
					bgcolor: 'background.paper',
					boxShadow: 24,
					p: { xs: 2, sm: 4 },
					borderRadius: 2,
					maxHeight: '80vh',
					overflowY: 'auto',
					textAlign: 'center',
				}}
			>
				{showCloseButton && (
					<IconButton
						onClick={onClose}
						sx={{
							position: 'absolute',
							top: 8,
							right: 8,
							color: 'grey.700',
						}}
					>
						✖
					</IconButton>
				)}

				{imageSrc && (
					<div style={{ padding: '2rem' }}>
						<img src={imageSrc} alt="Modal" width={150} />
					</div>
				)}
				<Typography
					id="modal-title"
					variant="h6"
					sx={{ fontSize: { xs: 24, sm: 26 } }}
				>
					{title}
				</Typography>
				<Typography
					id="modal-description"
					sx={{
						mt: 2,
						fontSize: { xs: 18, sm: 20 },
					}}
				>
					{description}
				</Typography>

				{showTextField && (
					<TextField
						label={textFieldLabel}
						variant="outlined"
						fullWidth
						value={textFieldValue}
						onChange={(e) => onTextFieldChange?.(e.target.value)}
					/>
				)}

				<Button
					variant="contained"
					color="primary"
					onClick={onButtonClick}
					sx={{ mt: 4, display: 'block', mx: 'auto' }}
				>
					{buttonText}
				</Button>

				{onSecondaryClick && (
					<Button
						variant="outlined"
						color="primary"
						onClick={onSecondaryClick}
						sx={{ mt: 4, display: 'block', mx: 'auto' }}
					>
						{secondaryButtonText}
					</Button>
				)}
			</Box>
		</Modal>
	);
};

export default ModalComponent;
